export default __webpack_public_path__ + "static/media/images-outline.6fa568c2.svg";